export const FILTERS_SEARCH_INIT = '[FILTERS] FILTERS_SEARCH_INIT';
export const FILTERS_SEARCH_SUCCESS = '[FILTERS] FILTERS_SEARCH_SUCCESS';
export const FILTERS_SEARCH_ERROR = '[FILTERS] FILTERS_SEARCH_ERROR';
export const FILTERS_CHANGE = '[FILTERS] FILTERS_CHANGE';
